export default [
    {
        goalName: 'showcase_offer_click',
        targetClass: 'lds-widget-card',
    },
    {
        goalName: 'popup_banner_click',
        targetClass: 'lds-popup-banner',
    },
    {
        goalName: 'banner_click',
        targetClass: 'lds-widget-banner',
    },
    {
        goalName: 'popup_offer_click',
        targetClass: 'lds-popup-offers-link',
    },
];